import React from "react";
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { change } from 'redux-form';
import cx from 'classnames';
import Loader from '../../Common/Loader';
import Dropzone from "./Dropzone/Dropzone";
import defaultIcon from '/public/dashboard/menu.svg';
import s from './ProfileImageUpload.css';
import n from '../../../styles/adminDropzone.css'

const ProfileImageUpload = (props) => {

	const {
		change,
		imageSrc,
		defaultMessage,
		loader,
		loaderName,
		postUrl,
		fieldName,
		formName,
		handleDropzone

	} = props

	const handleDropzoneImage = (fileName, fieldName, formName) => {
		change(formName, fieldName, fileName)
	};

	return (
		<div className="position-relative" >
			<div className={cx(s.profileImageSize, 'profileImagesizeLoader')}>
				{imageSrc &&
					<Loader show={loader} type={"page"} dropzoneLoaderClass={s.profileUpdateLoader}>
						<div className={s.profileBackgroundImg} style={{ backgroundImage: `url(${imageSrc})` }} />
					</Loader>
				}
				{!imageSrc && (
					<Loader show={loader} type="page" dropzoneLoaderClass={s.profileUpdateLoader}>
						<div
							className={s.profileBackgroundImg}
							style={{ backgroundImage: `url(${defaultIcon})` }}
						/>
					</Loader>
				)}
			</div>
			<Dropzone
				className={"profileUploaderBtn"}
				defaultMessage={defaultMessage}
				componentConfig={{
					iconFiletypes: ['.jpg', '.png', '.svg'],
					multiple: false,
					showFiletypeIcon: false,
					postUrl
				}}
				loaderName={loaderName}
				fieldName={fieldName}
				formName={formName}
				handleDropzone={handleDropzone ? handleDropzone : handleDropzoneImage}
				isLoader
			/>
		</div >
	)
}
const mapState = state => ({});

const mapDispatch = {
	change
};

export default withStyles(s, n)(connect(mapState, mapDispatch)(ProfileImageUpload));  